export const convertAttributeToBoolean = (value) => {
  return value !== undefined && value !== null && value !== false && value !== 'false';
};

export const convertAttributeToString = (value) => {
  if (typeof value === 'object' && value !== null) {
    return JSON.stringify(value);
  }

  return (value !== undefined && value !== null) ? value.toString() : '';
};

export const convertAttributeToArray = (value) => {
  let parsedValue = value;

  if (typeof parsedValue === 'string') {
    try {
      parsedValue = JSON.parse(value);
    } catch (err) {
      return [];
    }
  }

  if (Array.isArray(parsedValue)) {
    return parsedValue;
  }

  return [];
};

export const convertAttributeToObject = (value) => {
  let parsedValue = value;

  if (typeof parsedValue === 'string') {
    try {
      parsedValue = JSON.parse(value);
    } catch (err) {
      return {};
    }
  }

  if ((typeof parsedValue === 'object') && !Array.isArray(parsedValue)) {
    return parsedValue;
  }

  return {};
};
